"use client";

import { InferRequestType, InferResponseType } from "hono";
import { useMutation } from "@tanstack/react-query";
import { client } from "@/lib/hono";

type ResponseType = InferResponseType<
    (typeof client.api.storage)["lomda-v3"][":lomdaId"]["$patch"],
    200
>;
type RequestType = InferRequestType<
    (typeof client.api.storage)["lomda-v3"][":lomdaId"]["$patch"]
>["json"];

export const useUpdateLomdaV3 = (lomdaId: string) => {
    return useMutation<ResponseType, Error, RequestType>({
        mutationKey: ["lomda-v3", { lomdaId }],
        mutationFn: async (json) => {
            const response = await client.api.storage["lomda-v3"][
                ":lomdaId"
            ].$patch({
                param: { lomdaId },
                json,
            });

            if (!response.ok) {
                throw new Error("Failed to update lomdaV3");
            }

            return response.json();
        },
    });
};
